module.exports = __webpack_public_path__ + "img/1.身份证正面.f5d103d3.png";